import { Action } from '@anm/components/ActionsDropdown';
import StreamVideoAction from '@anm/components/dropdown-actions/streamVideo';
import { getDropdownAction } from '@anm/helpers/dropdownActions';
import { useSelector } from 'react-redux';

import config from '../../../../config';
import { userSelectors } from '../../../../store/modules/user';

const { urls } = config();

type StreamVideoActionProps = {
  projectId: string;
  canStreamVideo: boolean;
  handler?: () => void;
};

const useStreamVideoAction = ({ projectId, canStreamVideo, handler }: StreamVideoActionProps) => {
  const publishUrl = `${urls.editor}/#p=${projectId}&target=publish`;
  const isUserFree = useSelector(userSelectors.selectIsUserFree);

  const canStream = canStreamVideo && !isUserFree;

  const action = getDropdownAction('onStreamVideo');

  const streamVideoAction: Action = {
    icon: action.icon,
    disabled: !canStream,
    autoClose: canStream,
    renderComponent: () => (
      <StreamVideoAction {...{ action, handler, publishUrl, isUserFree }} canStreamVideo={canStream} />
    )
  };

  return streamVideoAction;
};

export default useStreamVideoAction;
